import React from 'react';
import { Calendar, Clock, ArrowRight, ExternalLink } from 'lucide-react';
import { articles as mockArticles } from '@/mock';
import '../styles/ArticlesSection.css';

const ArticlesSection = ({ articles: propsArticles, loading }) => {
  // Use props articles if available, otherwise use mock
  const articles = propsArticles && propsArticles.length > 0 ? propsArticles : mockArticles;

  const handleArticleClick = (article, e) => {
    e.preventDefault();
    if (article.link && article.link !== '#' && article.link !== '') {
      window.open(article.link, '_blank', 'noopener,noreferrer');
    }
  };

  if (loading) {
    return (
      <section className="articles-section" id="articles">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Latest Articles</h2>
            <div className="title-underline"></div>
          </div>
          <div style={{ textAlign: 'center', color: '#a3a3a3', padding: '3rem' }}>
            Loading articles...
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className="articles-section" id="articles">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Latest Articles</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">Thoughts on mobile development and leadership</p>
        </div>

        <div className="articles-grid">
          {articles.map((article, index) => {
            const hasLink = article.link && article.link !== '#' && article.link !== '';
            return (
              <div 
                key={article.id} 
                className={`article-card ${hasLink ? 'clickable' : ''}`}
                style={{ animationDelay: `${index * 0.1}s` }}
                onClick={hasLink ? (e) => handleArticleClick(article, e) : undefined}
                data-testid={`article-card-${article.id}`}
              >
                <div className="article-image-container">
                  <img src={article.image} alt={article.title} className="article-image" />
                  <span className="article-category">{article.category}</span>
                </div>

                <div className="article-content">
                  <h3 className="article-title">{article.title}</h3>
                  <p className="article-excerpt">{article.excerpt}</p>

                  <div className="article-meta">
                    <span className="meta-item">
                      <Calendar size={14} />
                      {new Date(article.date).toLocaleDateString('en-US', { 
                        month: 'short', 
                        day: 'numeric', 
                        year: 'numeric' 
                      })}
                    </span>
                    <span className="meta-item">
                      <Clock size={14} />
                      {article.readTime}
                    </span>
                  </div>

                  <button 
                    className={`read-more-btn ${hasLink ? '' : 'disabled'}`}
                    onClick={hasLink ? (e) => handleArticleClick(article, e) : (e) => e.preventDefault()}
                  >
                    {hasLink ? (
                      <>
                        Read Article
                        <ExternalLink size={16} />
                      </>
                    ) : (
                      <>
                        Coming Soon
                        <ArrowRight size={16} />
                      </>
                    )}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ArticlesSection;